import { useEffect, useState } from "react";
import * as ach from "core/src/achievements/achievements.js";
import { useAuth } from "../auth";
import { fetchPlayerAchievements } from "../rating/store";
import { viewAchievements } from "../rating/achievements";
import { DEMO } from "../design-flags";

// The achievement level within reach, for the start page: of the ones that
// count up as you play (not a rating, a best day or a one-off moment), the one
// nearest its next level by the share of the way there, once it has begun.
export interface NextAchievement { id: string; icon: string; name: string; level: number; value: number; from: number; to: number; eggs: number }

const COUNTING = ["certified-worm", "food-chain", "podium-regular", "ranked-regular", "duelist", "giant-slayer", "royale-regular", "round-robin", "needle-threader", "power-hungry", "wall-builder"];

function pick(progress: any, levels: Record<string, number> | null): NextAchievement | null {
  let best: NextAchievement | null = null, bestShare = -1;
  for (const v of viewAchievements(progress, levels)) {
    if (v.done || v.to == null || v.nextEggs == null || COUNTING.indexOf(v.id) === -1) continue;
    const share = (v.value - v.from) / Math.max(1, v.to - v.from);
    if (v.value <= v.from || share <= bestShare) continue;
    bestShare = share;
    const a = ach.achievementById(v.id);
    best = { id: v.id, icon: v.icon, name: ach.levelName(a, v.level + 1), level: v.level + 1, value: v.value, from: v.from, to: v.to, eggs: v.nextEggs };
  }
  return best;
}

// (kept between visits to the start page, so it is there at once and the read
// corrects it)
let cache: { uid: string; next: NextAchievement | null } | null = null;
const DEMO_NEXT: NextAchievement = { id: "needle-threader", icon: "🧵", name: "Needle Threader II", level: 2, value: 41, from: 10, to: 50, eggs: 3 };

export function useNextAchievement(): NextAchievement | null {
  const { user } = useAuth();
  const uid = user?.id ?? null;
  const [next, setNext] = useState<NextAchievement | null>(() => (DEMO ? DEMO_NEXT : cache && cache.uid === uid ? cache.next : null));
  useEffect(() => {
    if (DEMO) return;
    if (!uid) { setNext(null); return; }
    let live = true;
    fetchPlayerAchievements(uid).then((row) => {
      if (!live || row === null) return; // (null: it could not be read; keep what there was)
      const n = row ? pick(row.progress, row.levels) : null;
      cache = { uid, next: n };
      setNext(n);
    });
    return () => { live = false; };
  }, [uid]);
  return next;
}
